export const GET_ANALYTICS = 'GET_ANALYTICS';

export const GET_ANALYTICS_FAILED = 'GET_ANALYTICS_FAILED';
export const GET_ANALYTICS_SUCCESS = 'GET_ANALYTICS_SUCCESS';
export const GET_ANALYTICS_RESET = 'GET_ANALYTICS_RESET';
